export default __webpack_public_path__ + "static/media/FlatUparrow.e59634fb.svg";